import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaforweddingevents() {



    const cardData =
    {
        keyword: 'Urbania for Wedding Events in Pune',
        heading: 'Urbania on rent in pune: Urbania for Wedding Events in Pune',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable Urbania for Wedding Events in Pune to ensure smooth and comfortable transportation for wedding functions and celebrations. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and a refined ride, making it ideal for guest transportation, bride and groom family travel, airport transfers, and outstation wedding trips. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from all major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure timely and stress-free movement during every wedding event. Backed by 24/7 booking support, punctual service, and transparent pricing, Urbania On Rent in Pune stands out as the trusted choice for elegant and reliable Urbania hire for wedding events in Pune.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical fort and a powerful symbol of Maratha pride. Once the administrative center of Bajirao I, it features massive stone walls, majestic gates like the Delhi Darwaza, and spacious courtyards. Although a major fire destroyed much of the structure, the remaining fort reflects royal grandeur. The evening light-and-sound show narrates Maratha history, making it a must-visit heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is one of Pune’s most important landmarks connected to India’s freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. The palace now houses a museum displaying Gandhi’s personal belongings, photographs, and letters. Its Italian-style arches, lush lawns, and peaceful environment make it both historically significant and visually stunning."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous and revered Ganesh temple. The idol is richly adorned with gold ornaments and attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the heart of Pune’s grand celebrations with processions and cultural programs. The temple trust is also well known for its social and charitable initiatives, making it spiritually and socially significant."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fortress located amidst the Sahyadri ranges and is famous for the legendary battle fought by Tanaji Malusare. The fort offers panoramic views of Pune city, ancient bastions, memorials, and scenic trekking routes. Visitors enjoy traditional Maharashtrian food like pithla-bhakri at the top. It is a perfect destination combining history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi mandap, and ancient carvings reflecting early Indian craftsmanship. Despite being located in a busy area, the temple maintains a calm and spiritual ambiance, offering a peaceful retreat within the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected from across India, showcasing traditional art, musical instruments, sculptures, and household items. One of its highlights is the recreated Mastani Mahal. The museum offers deep insight into India’s cultural heritage and is a treasure trove for history lovers, students, and art enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks and offers breathtaking panoramic views after climbing 103 stone steps. The hilltop Parvati Temple, built during the Peshwa era, is dedicated to Lord Shiva and Goddess Parvati. The complex also includes smaller shrines and a museum. Sunrise and sunset views from the hill are especially captivating."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a globally renowned center for meditation, mindfulness, and wellness. Surrounded by lush gardens, it attracts visitors from around the world seeking peace, relaxation, and self-discovery. The serene atmosphere and unique meditation techniques make it a distinctive spiritual destination in Pune."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. It features flowing water streams, stone bridges, manicured lawns, and seasonal flowers. The garden offers a peaceful environment for walks, photography, and family outings, beautifully blending Japanese aesthetics with Indian natural beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular picnic and leisure spot near Pune. The expansive water body, surrounding hills, and cool breezes create a scenic setting, especially during monsoon and evenings. Local vendors selling corn and tea add to its charm. It also serves as the gateway to Sinhagad Fort, making it a favorite weekend getaway."
  }
],



"services": [
    {
      "name": "Urbania for Wedding Events in Pune",
      "description": "Urbania for Wedding Events in Pune provides reliable and comfortable transportation solutions for weddings and related ceremonies. With spacious seating, air-conditioned vehicles, professional chauffeurs, and well-maintained interiors, this service ensures smooth and stress-free travel for guests, family members, and wedding parties across Pune."
    },
    {
      "name": "Wedding Urbania Bus Hire Pune",
      "description": "Wedding Urbania Bus Hire Pune offers spacious buses ideal for transporting wedding guests, relatives, and groups between venues. Designed for comfort and punctuality, these buses come with professional drivers, ample seating, and organized scheduling to manage wedding logistics efficiently."
    },
    {
      "name": "Urbania for Marriage Functions Pune",
      "description": "Urbania for Marriage Functions Pune specializes in providing transportation for engagement ceremonies, receptions, and traditional marriage events. With clean, comfortable vehicles and trained chauffeurs, it ensures timely and hassle-free movement of guests and family members."
    },
    {
      "name": "Urbania Guest Transport Pune",
      "description": "Urbania Guest Transport Pune offers dependable travel solutions for wedding guests arriving from different locations. Vehicles are spacious, well-maintained, and driven by courteous chauffeurs, ensuring guests experience comfort, safety, and timely transfers throughout the wedding celebrations."
    },
    {
      "name": "Urbania AC Wedding Bus Pune",
      "description": "Urbania AC Wedding Bus Pune provides fully air-conditioned buses to keep guests comfortable during wedding travel. Ideal for large groups and long-distance venue transfers, these buses ensure a relaxed and pleasant journey with professional chauffeur service."
    },
    {
      "name": "Luxury Wedding Urbania Pune",
      "description": "Luxury Wedding Urbania Pune offers premium Urbania vehicles with plush interiors for high-end wedding events. Perfect for VIP guests, close family members, and special occasions, this service delivers elegance, superior comfort, and professional chauffeur-driven transportation."
    },
    {
      "name": "Affordable Wedding Urbania Hire Pune",
      "description": "Affordable Wedding Urbania Hire Pune provides cost-effective wedding transportation solutions without compromising on comfort or service quality. Suitable for families and large guest groups, the service ensures clean vehicles, reliable drivers, and punctual wedding-day travel."
    },
    {
      "name": "Chauffeur Driven Wedding Urbania Pune",
      "description": "Chauffeur Driven Wedding Urbania Pune ensures stress-free wedding transportation with trained, background-verified drivers. Vehicles are well-maintained and spacious, allowing families and guests to travel safely and comfortably between wedding venues."
    },
    {
      "name": "Urbania for Baraat Pune",
      "description": "Urbania for Baraat Pune provides organized and comfortable transportation for the baraat procession. With spacious seating, professional drivers, and coordinated movement, the service helps manage group travel smoothly while maintaining comfort and safety."
    },
    {
      "name": "Urbania for Family Wedding Travel Pune",
      "description": "Urbania for Family Wedding Travel Pune offers reliable transport for close family members during wedding ceremonies. With ample luggage space, air-conditioned comfort, and courteous chauffeurs, families can focus on celebrations while travel logistics are handled smoothly."
    },
    {
      "name": "Corporate Wedding Transport Urbania Pune",
      "description": "Corporate Wedding Transport Urbania Pune provides professional transportation for corporate-sponsored weddings and formal wedding events. Vehicles are clean, punctual, and chauffeur-driven, ensuring a professional and organized travel experience for guests and dignitaries."
    },
    {
      "name": "Best Wedding Urbania Rental Pune",
      "description": "Best Wedding Urbania Rental Pune delivers top-rated wedding transportation services known for reliability, vehicle quality, and customer satisfaction. Ideal for weddings of all sizes, it ensures smooth, timely, and comfortable travel for all guests."
    },
    {
      "name": "Urbania Group Wedding Travel Pune",
      "description": "Urbania Group Wedding Travel Pune specializes in transporting large groups of wedding guests efficiently and comfortably. With spacious vehicles, professional chauffeurs, and organized scheduling, it ensures seamless group travel between wedding venues."
    },
    {
      "name": "Reliable Wedding Urbania Service Pune",
      "description": "Reliable Wedding Urbania Service Pune focuses on punctuality, safety, and comfort for wedding transportation. With well-maintained vehicles and experienced chauffeurs, it provides peace of mind for families managing multiple wedding events."
    },
    {
      "name": "Wedding Event Transport Urbania Pune",
      "description": "Wedding Event Transport Urbania Pune offers complete transportation solutions for wedding ceremonies, receptions, and related functions. From guest pickups to venue transfers, the service ensures organized, comfortable, and stress-free travel throughout the wedding celebrations."
    }
  ],
  "tableData": [
    ["Urbania for Wedding Events in Pune", "Wedding Urbania Bus Hire Pune"],
    ["Urbania for Marriage Functions Pune", "Urbania Guest Transport Pune"],
    ["Urbania AC Wedding Bus Pune", "Luxury Wedding Urbania Pune"],
    ["Affordable Wedding Urbania Hire Pune", "Chauffeur Driven Wedding Urbania Pune"],
    ["Urbania for Baraat Pune", "Urbania for Family Wedding Travel Pune"],
    ["Corporate Wedding Transport Urbania Pune", "Best Wedding Urbania Rental Pune"],
    ["Urbania Group Wedding Travel Pune", "Reliable Wedding Urbania Service Pune"],
    ["Wedding Event Transport Urbania Pune", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Perfect Urbania for Wedding Events in Pune",
        "WhyChoosedescription": "Urbania for Wedding Events in Pune is an ideal choice for transporting guests comfortably during weddings, receptions, engagements, and related ceremonies."
    },
    {
        "WhyChooseheading": "Luxury and Spacious Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania for Wedding Events in Pune offers premium Force Urbania vehicles with spacious seating and ample luggage space for wedding guests and family members."
    },
    {
        "WhyChooseheading": "Professional and Courteous Drivers",
        "WhyChoosedescription": "Urbania for Wedding Events in Pune comes with experienced and well-mannered drivers who ensure safe, smooth, and respectful transportation for all wedding functions."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Wedding Pricing",
        "WhyChoosedescription": "Choose Urbania for Wedding Events in Pune for competitive wedding transportation rates with no hidden charges."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania for Wedding Events in Pune provides round-the-clock booking assistance and support to manage multiple wedding schedules seamlessly."
    },
    {
        "WhyChooseheading": "Flexible Wedding Transportation Packages",
        "WhyChoosedescription": "Urbania for Wedding Events in Pune is available for full-day bookings, multi-day rentals, guest pickup and drop services, and customized wedding travel plans."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Decor-Ready Vehicles",
        "WhyChoosedescription": "All Urbania vehicles used for wedding events in Pune are thoroughly cleaned, sanitized, and can be decorated as per wedding themes."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Wedding Service",
        "WhyChoosedescription": "Urbania for Wedding Events in Pune guarantees on-time arrivals and reliable service for smooth and stress-free wedding transportation."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania for Wedding Events in Pune suitable for guest transportation?',
        answer: 'Yes, Urbania for Wedding Events in Pune is ideal for transporting wedding guests, family members, and relatives comfortably.',
    },
    {
        question: 'How can I book Urbania for Wedding Events in Pune?',
        answer: 'You can book Urbania for Wedding Events in Pune via phone call, WhatsApp, or online booking for easy reservations.',
    },
    {
        question: 'Can Urbania vehicles be decorated for weddings?',
        answer: 'Yes, Urbania for Wedding Events in Pune allows vehicle decoration as per wedding themes and requirements.',
    },
    {
        question: 'Is Urbania for Wedding Events in Pune available for full-day and multi-day bookings?',
        answer: 'Yes, Urbania for Wedding Events in Pune is available for full-day and multi-day wedding transportation packages.',
    },
    {
        question: 'Are drivers trained for wedding event services?',
        answer: 'Yes, all drivers are experienced, professional, and trained to handle wedding event transportation with care and punctuality.',
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Urbania for Wedding Events in Pune allows flexible pickup and drop locations across Pune.',
    },
    {
        question: 'Is Urbania for Wedding Events in Pune available 24x7?',
        answer: 'Yes, Urbania for Wedding Events in Pune operates 24x7 to support all wedding functions and schedules.',
    },
    {
        question: 'Are vehicles sanitized before wedding events?',
        answer: 'Yes, all Urbania vehicles are thoroughly cleaned and sanitized before every wedding event.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Urbania for Wedding Events in Pune accepts UPI, cards, bank transfers, digital wallets, and corporate or bulk billing.',
    },
    {
        question: 'Is customer support available during wedding events?',
        answer: 'Yes, dedicated customer support is available throughout wedding events to ensure smooth coordination.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Pravin Jadhav',
        feedback: 'We hired Urbania for our wedding events in Pune. The vehicle was clean, spacious, and perfect for guest transportation.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Kulkarni',
        feedback: 'Urbania for Wedding Events in Pune provided excellent and punctual service. Our guests were very comfortable.',
        rating: 5,
    },
];






































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania for Wedding Events in Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-wedding-events-pune.jpg",
  "description": "Urbania for Wedding Events in Pune offers AC and non-AC Urbania buses for wedding guest transport, baraat processions, family travel, and corporate wedding transfers. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation for all wedding occasions in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "20000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-for-wedding-events-pune"
  }
};












    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania for Wedding Events in Pune | AC & Luxury Wedding Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Urbania for Wedding Events in Pune for guest transport, baraat processions, family travel, and corporate wedding transfers. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient wedding transportation in Pune."
  />

  <meta
    name="keywords"
    content="Urbania for Wedding Events in Pune, Wedding Urbania Bus Hire Pune, Urbania for Marriage Functions Pune, Urbania Guest Transport Pune, Urbania AC Wedding Bus Pune, Luxury Wedding Urbania Pune, Affordable Wedding Urbania Hire Pune, Chauffeur Driven Wedding Urbania Pune, Urbania for Baraat Pune, Urbania for Family Wedding Travel Pune, Corporate Wedding Transport Urbania Pune, Best Wedding Urbania Rental Pune, Urbania Group Wedding Travel Pune, Reliable Wedding Urbania Service Pune, Wedding Event Transport Urbania Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/50.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaforweddingevents;